import {useMutation} from '@tanstack/react-query';
import ChessRestClient from '@/Api/ChessRestClient';

export type CsocPauseLimitsResponse = {
  min_pause_days: number;
  max_pause_days_allowed: number;
  redeemed_pause_days: number;
  max_pause_days_remaining: number;
  min_pause_end_date: string;
  max_pause_end_date: string | null;
};

export default function useGetCsocPauseLimits(
  handleOnSuccess?: (data: CsocPauseLimitsResponse) => void,
  handleOnError?: (error: any) => void,
) {
  const mutation = useMutation({
    mutationFn: async (payload: {order_id: string}) => {
      const response = await ChessRestClient.get(
        'subscription/v1/csoc/pause-limits',
        {params: payload},
      );
      return response.data as CsocPauseLimitsResponse;
    },
    onSuccess: data => {
      if (handleOnSuccess) handleOnSuccess(data);
    },
    onError: error => {
      if (handleOnError) handleOnError(error);
    },
  });

  return {
    ...mutation,
  };
}
